import React, { useState } from "react";
import { Button, Input, Table, Form } from "antd";



const Table1 = ({ columnsConfig, data, total, pageSize = 10, onChange }) => {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");

    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        form.setFieldsValue({ ...record });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey("");
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            console.log("Updated row:", row); // 🔥 send to API
            setEditingKey("");
        } catch (errInfo) {
            console.log("Validate Failed:", errInfo);
        }
    };

    //  Only attach onCell when editable: true
    const mergedColumns = columnsConfig.map((col) => {
        if (!col.editable) {
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: false, // 👈 force false
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: isEditing(record),
                }),
            };
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
                editable: true, // 👈 explicitly true
            }),
        };
    });



    return (
        <Form form={form} component={false}>
            <Table
                className="table-clr"
                columns={mergedColumns}
                dataSource={data}
                pagination={{
                    total,
                    pageSize,
                    showSizeChanger: false,
                    showTotal: (total) => `Total ${total} items`,
                    style: {background:"#212738",color:"white"},
                    className:"pagination-clr"
                }}
                onChange={onChange}
                rowClassName="editable-row"
                scroll={{
                    x: "800", // horizontal scroll if many columns
                    // y: 400,           // vertical scroll (set height in px)
                }}
            />
        </Form>
    );
};

export default Table1;
